import { Directive, inject, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { UPLOAD_FILE_API } from '../token';

@Directive({ selector: '[portalPreviewFile]', standalone: true, exportAs: 'portalPreviewFile' })
export class PreviewFileDirective implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private readonly api = inject(UPLOAD_FILE_API);

  @Input() file?: File;
  @Input() keyName?: string;

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  previewFile(): void {
    if (this.file) {
      const url = URL.createObjectURL(this.file);
      this.openFileInNewTab(url);
      return;
    }

    if (this.keyName) {
      this.api
        .getPublicLink({ keyName: this.keyName })
        /**
         * Always open file when keyName exist, even if user navigate away from the page.
         * So we don't complete the observable when component destroyed.
         */
        // .pipe(take(1), takeUntil(this.destroy$))
        .subscribe(url => this.openFileInNewTab(url));
      return;
    }

    throw new Error('File or keyName is required');
  }

  /**
   * Issue: Cant open new tab in Safari.
   * RCA: In all browser mobile, user blocked the popup window.
   * Solution: https://stackoverflow.com/a/39387533
   */
  private openFileInNewTab(url: string): void {
    const windowRef = window.open();
    if (windowRef) windowRef.location = url;

    // private linkRef?: HTMLAnchorElement;
    // private clickEvent?: MouseEvent;
    // if (!this.linkRef) {
    //   this.linkRef = document.createElement('a');
    // }
    //
    // if (!this.clickEvent) {
    //   this.clickEvent = new MouseEvent('click');
    // }
    //
    // this.linkRef.setAttribute('href', url);
    // this.linkRef.setAttribute('target', '_blank');
    // this.linkRef.dispatchEvent(this.clickEvent);
  }
}
